var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default').default;

(function () {
  Flint.file('views/girlsGameEmbeds.js', function (require) {
    var _data = require('../data');

    var _data2 = _interopRequireDefault(_data);

    Flint.staticStyles('GirlsGameEmbeds', {
      '$': '#_flintapp .ViewGirlsGameEmbeds',
      '$ggEmbed': '#_flintapp ggEmbed.GirlsGameEmbeds, #_flintapp .GirlsGameEmbeds.ggEmbed, #_flintapp .ViewGirlsGameEmbeds.ggEmbed, #_flintapp .GirlsGameEmbeds > .ggEmbed',
      '$previewSec': '#_flintapp previewSec.GirlsGameEmbeds, #_flintapp .GirlsGameEmbeds.previewSec, #_flintapp .ViewGirlsGameEmbeds.previewSec, #_flintapp .GirlsGameEmbeds > .previewSec',
      '$ggVideo': '#_flintapp ggVideo.GirlsGameEmbeds, #_flintapp .GirlsGameEmbeds.ggVideo, #_flintapp .ViewGirlsGameEmbeds.ggVideo, #_flintapp .GirlsGameEmbeds > .ggVideo',
      '$thumb': '#_flintapp thumb.GirlsGameEmbeds, #_flintapp .GirlsGameEmbeds.thumb, #_flintapp .ViewGirlsGameEmbeds.thumb, #_flintapp .GirlsGameEmbeds > .thumb',
      '$play': '#_flintapp play.GirlsGameEmbeds, #_flintapp .GirlsGameEmbeds.play, #_flintapp .ViewGirlsGameEmbeds.play, #_flintapp .GirlsGameEmbeds > .play',
      '$captionSec': '#_flintapp captionSec.GirlsGameEmbeds, #_flintapp .GirlsGameEmbeds.captionSec, #_flintapp .ViewGirlsGameEmbeds.captionSec, #_flintapp .GirlsGameEmbeds > .captionSec',
      '$videoTitle': '#_flintapp videoTitle.GirlsGameEmbeds, #_flintapp .GirlsGameEmbeds.videoTitle, #_flintapp .ViewGirlsGameEmbeds.videoTitle, #_flintapp .GirlsGameEmbeds > .videoTitle'
    }, {
      '$': {
        flexDirection: 'row',
        flexGrow: 1,
        flexWrap: 'wrap',
        justifyContent: 'space-between'
      },
      '$ggEmbed': {},
      '$previewSec': {
        position: 'relative'
      },
      '$ggVideo': {},
      '$thumb': {
        borderRadius: 4
      },
      '$play': {
        position: 'absolute',
        width: 40,
        height: 40,
        zIndex: 1,
        margin: 'auto',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
      },
      '$captionSec': {
        flexGrow: 1,
        alignSelf: 'stretch',
        alignItems: 'center'
      },
      '$videoTitle': {
        textAlign: 'center',
        color: 'white',
        fontSize: 12,
        fontWeight: 'bold',
        marginTop: 4
      }
    });
    Flint.view('GirlsGameEmbeds', function (view, on, $) {
      var context = initContext(view, {
        isMobile: atom()
      });

      var pro = initPro(view, {
        numEpisodes: M.defaultAtom(4),
        style: M.mergeAtom({
          width: 400
        })
      });

      var getExternalUrl = function getExternalUrl(ggEpisode) {
        return 'http://thegirlsgame.tv/yahoo/s' + ggEpisode.season + ('e' + ('0' + ggEpisode.episode).slice(-2));
      };

      var spacing = atom(22);

      var embedWidth = derivation(function () {
        if (context.isMobile.get()) {
          return (pro.style.get().get('width') - 3 * spacing.get()) / 2;
        } else {
          return (pro.style.get().get('width') - (pro.numEpisodes.get() + 1) * spacing.get()) / pro.numEpisodes.get();
        }
      });
      var embedHeight = embedWidth.derive(function (w) {
        return w * 9 / 16;
      });

      var episodes = _data2.default.girlsGameEpisodes.toJS();
      M.util.shuffle(episodes);view.render(function () {
        return Flint.range(episodes.slice(0, pro.numEpisodes.get())).map(function (_, _index) {
          return view.el(
            ['ggEmbed', 1, _, _index],
            { repeat: episodes.slice(0, pro.numEpisodes.get()) },
            view.el(
              ['previewSec', 1, _, _index],
              null,
              view.el(
                ['Link', 1, _, _index],
                {
                  to: getExternalUrl(_),
                  target: '_blank'
                },
                view.el(['img', 1, _, _index], { className: 'play', src: '/images/playicon.png' }),
                view.el(['img', 2, _, _index], { className: 'thumb',
                  src: _.thumbUrl
                })
              ),
              Flint.iff(false) && view.el(['iframe', 1, _, _index], { className: 'ggVideo', if: false,
                src: _.url + '?format=embed',
                scrolling: 'no',
                frameBorder: '0',
                allowFullScreen: 'true',
                allowtransparency: 'true'
              })
            ),
            view.el(
              ['captionSec', 1, _, _index],
              null,
              view.el(
                ['Link', 2, _, _index],
                { className: 'videoTitle', to: getExternalUrl(_) },
                _.title
              )
            )
          );
        });
      });

      $["$"] = function (_, _index) {
        return { padding: [spacing.get(), spacing.get(), 0]
        };
      };

      $["ggEmbed"] = function (_, _index) {
        return {
          width: embedWidth.get(),
          marginBottom: spacing.get()
        };
      };

      'a2cbb15a';

      $["ggVideo"] = function (_, _index) {
        return {
          width: embedWidth.get(),
          height: embedHeight.get()
        };
      };

      '64cf7984';

      $["thumb"] = function (_, _index) {
        return {
          width: embedWidth.get(),
          height: embedHeight.get() };
      };

      'f0f18014';
      'dc086c74';
      '3339d717';
    });
  })
})();
//# sourceMappingURL=girlsGameEmbeds.js.map
